import Themes from '../../enums/Themes'
import * as types from '../mutation-types'

const STORAGE_KEY_THEME = 'theme'

// Sync local storage -- THEME
let savedStorageTheme = null
try {
  savedStorageTheme = JSON.parse(localStorage.getItem(STORAGE_KEY_THEME))
} catch (e) {
  savedStorageTheme = null
}

// Detect system theme preference
let isSystemDark = false
try {
  isSystemDark = window.matchMedia('(prefers-color-scheme: dark)').matches
} catch (e) {
  console.log('Error detecting system theme preference:', e)
}
const systemTheme = {
  displayName: Themes.system,
  name: isSystemDark ? Themes.dark : Themes.light,
  isDark: isSystemDark
}

const state = {
  theme: savedStorageTheme || systemTheme
}

const getters = {
  theme: state => state.theme
}

const actions = {
  toggleTheme({ commit }, value) {
    commit(types.Toggle_Theme, value)
  }
}

const mutations = {
  [types.Toggle_Theme](state, value) {
    state.theme.displayName = value
    if (value === Themes.system) {
      state.theme.isDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      state.theme.name = state.theme.isDark ? Themes.dark : Themes.light
    } else {
      state.theme.name = value
      state.theme.isDark = value === Themes.dark
    }
    localStorage.setItem(STORAGE_KEY_THEME, JSON.stringify(state.theme))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
